module.exports = __webpack_public_path__ + "static/media/deta.bcf6c056.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/deta.jpg
// module id = 1557
// module chunks = 0